<template>
    <div class="goods" :class="{ 'goods--layout-mobile-stack': layoutMobileStack }">
        <div class="container">
            <my-popup :is-show="isShow" :title="title" right="发券" @leftHandler="toggleShowPopup" @rightHandler="openCouponPopup">
                <div class="content">
                    <div class="goods-item-outer" v-for="(item, index) in list" :key="item.id">
                    <div class="goods-item">
                        <div class="left-serial">{{ index + 1 }}</div>
                        <div class="right-goods-info">
                            <div class="goods-img-box">
                                <img
                                    class="goods-img"
                                    :src="item.goods_info.goods_master_img | goodsImg"
                                    :alt="item.goods_info.goods_name"
                                    :title="item.goods_info.goods_name"
                                />
                                <div class="state-mask-box" v-if="item.maskStatus != 0">
                                    <div class="state" v-if="item.maskStatus == 1">
                                        <i class="icon iconfont">&#xe63c;</i>
                                        <span>讲解中</span>
                                    </div>
                                    <div class="state state-end" v-else-if="item.maskStatus == 2">已讲解</div>
                                </div>
                            </div>
                            <div class="goods-info">
                                <div class="top-info">
                                    <div class="title">{{ item.goods_info.goods_name }}</div>
                                    <div class="coupon-info" v-if="couponMap[item.goods_id] && couponMap[item.goods_id].length > 0">
                                        <template v-for="couponItem in couponMap[item.goods_id]">
                                            <div class="coupon-item" :key="couponItem.id" @click="openCouponPopup(item.goods_id)">
                                                <template v-if="couponItem.type == 1">
                                                    <span class="decorate">券</span>
                                                    <span>
                                                        满{{ parseInt(couponItem.coupon_full) }}减{{
                                                            parseInt(couponItem.coupon_minus)
                                                        }}
                                                    </span>
                                                </template>
                                                <template v-else>
                                                    <span class="decorate">券</span>
                                                    <span
                                                        >满{{ parseInt(couponItem.coupon_full) }}打{{
                                                            parseInt(couponItem.coupon_minus)
                                                        }}折</span
                                                    >
                                                </template>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <div class="bottom-price">
                                    <span class="decorate">￥</span>
                                    <span>{{ item.goods_info.goods_discount_price }}</span>
                                </div>
                            </div>
                            <div class="action">
                                <el-button class="item release" v-if="item.status == 0" @click="release(item)">发布</el-button>
                                <el-button class="item lose" v-else-if="item.status == 1" @click="fall(item)">下架</el-button>
                                <el-button class="item finish" v-else-if="item.status == 2">发布</el-button>
                                <el-button class="item finish" v-else-if="item.status == 3">下架</el-button>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </my-popup>
        </div>
    </div>
</template>

<script>
import MyPopup from "./containers/MyPopup";

export default {
    name: "GoodsPopup",
    data() {
        return {};
    },
    props: {
        isShow: {
            type: Boolean,
            default: false,
        },
        list: {
            type: Array,
            default: () => [],
        },
        couponList: {
            type: Array,
            default: () => [],
        },
        /** 手机宫格：弹层容器最小宽度，列表区支持横纵滚动查看 */
        layoutMobileStack: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        title() {
            return `已选商品 (${this.list.length})`;
        },
        couponMap() {
            const allCoupon = this.couponList.reduce(
                (arr, item) => arr.concat(item.child.map((subItem) => ({ ...subItem, type: item.coupon_type }))),
                []
            );
            const map = {};
            allCoupon.forEach((item) => {
                if (map[item.goods_id] && map[item.goods_id].length < 2) {
                    map[item.goods_id].push(item);
                } else if (!map[item.goods_id]) {
                    map[item.goods_id] = [item];
                }
            });
            return map;
        },
    },
    components: {
        MyPopup,
    },
    filters: {
        goodsImg(src) {
            return `${localStorage.getItem("host_url")}${src}`;
        },
    },
    methods: {
        toggleShowPopup() {
            this.$emit("update:isShow", false);
        },
        openCouponPopup(goodsId = "") {
            this.$emit("openCouponPopup", goodsId);
        },
        release(item) {
            this.$emit("release", { check: "goods", item });
        },
        fall(item) {
            this.$emit("fall", item);
        },
    },
    mounted() {},
};
</script>

<style scoped lang="scss">
.goods--layout-mobile-stack {
    > .container {
        min-width: 560px;
    }

    /* MyPopup 内默认隐藏横向滚动；此处放开横纵，便于小视口查看未露出内容 */
    ::v-deep .el-scrollbar__wrap {
        overflow: auto !important;
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: contain;
    }

    /* 列表根节点随内容撑开宽度，由外层滚动条承接 */
    ::v-deep .el-scrollbar__view .content {
        min-width: 300px;
    }

    .goods-item-outer .right-goods-info {
        overflow: visible;

        .goods-info {
            min-width: min-content;
            overflow: visible;

            .top-info {
                overflow: visible;

                .title {
                    overflow: visible;
                    text-overflow: clip;
                }

                .coupon-info {
                    overflow: visible;
                    flex-wrap: nowrap;

                    .coupon-item {
                        flex-shrink: 0;
                        overflow: visible;
                        text-overflow: clip;
                    }
                }
            }
        }
    }
}

.goods {
    .container {
        .content {
            display: flex;
            flex-direction: column;

            .goods-item-outer {
                width: 100%;
            }

            .goods-item {
                /* 列表行内 cqw 相对于本行宽度，便于缩略图、按钮等随弹层变窄 */
                container-type: inline-size;
                box-sizing: border-box;
                display: flex;
                padding-right: 20px;
                padding-right: clamp(10px, 3.5cqw, 20px);
                .left-serial {
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    width: 55px;
                    width: clamp(40px, 11cqw, 55px);
                    padding: 20px 0;
                    padding: clamp(10px, 3.8cqw, 20px) 0;
                    font-family: 缁忓吀缁艰壓浣撶畝;
                    font-size: 18px;
                    font-size: clamp(13px, 4.2cqw, 18px);
                    color: #1b162a;
                }
                .right-goods-info {
                    display: flex;
                    flex: 1;
                    min-width: 0;
                    padding: 20px 0 20px;
                    padding: clamp(10px, 3.5cqw, 20px) 0;
                    border-bottom: 1px solid #ddd;
                    overflow: hidden;
                    .goods-img-box {
                        position: relative;
                        flex-shrink: 0;
                        width: 115px;
                        width: clamp(72px, 22cqw, 115px);
                        aspect-ratio: 1 / 1;
                        vertical-align: middle;
                        .goods-img {
                            display: block;
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                        .state-mask-box {
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            top: 0;
                            right: 0;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            background-color: rgba(0, 0, 0, 0.3);
                            .state {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                width: 80px;
                                width: clamp(56px, 20cqw, 80px);
                                height: 30px;
                                height: clamp(24px, 7cqw, 30px);
                                color: #fff;
                                font-size: 14px;
                                font-size: clamp(11px, 3.2cqw, 14px);
                                border-radius: 4px;
                                background-color: #fb0f4b;
                                .icon {
                                    margin-right: 6px;
                                    font-size: 14px;
                                    font-size: clamp(11px, 3.2cqw, 14px);
                                }
                            }
                            .state-end {
                                background-color: #a0a0a0;
                            }
                        }
                    }
                    .goods-info {
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        min-width: 0;
                        margin: 0 10px 0 20px;
                        margin: 0 clamp(6px, 2.2cqw, 10px) 0 clamp(10px, 4.5cqw, 20px);
                        overflow: hidden;
                        .top-info {
                            flex: 1;
                            display: flex;
                            flex-direction: column;
                            width: 100%;
                            overflow: hidden;
                            .title {
                                font-size: 18px;
                                font-size: clamp(14px, 4.8cqw, 18px);
                                color: #1b162a;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            }
                            .coupon-info {
                                display: flex;
                                flex-wrap: nowrap;
                                width: 100%;
                                margin-top: 10px;
                                margin-top: clamp(6px, 2cqw, 10px);
                                .coupon-item {
                                    margin-right: 10px;
                                    margin-right: clamp(6px, 2cqw, 10px);
                                    padding: 2px 9px;
                                    padding: clamp(2px, 0.6cqw, 4px) clamp(6px, 2.2cqw, 9px);
                                    font-size: 14px;
                                    font-size: clamp(11px, 3cqw, 14px);
                                    color: #fe3266;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                    border: 1px solid #fe3266;
                                    border-radius: 4px;
                                    cursor: pointer;
                                    .decorate {
                                        margin-right: 9px;
                                        margin-right: clamp(5px, 1.8cqw, 9px);
                                    }
                                }
                                .coupon-item:nth-child(2n) {
                                    margin-right: 0;
                                }
                            }
                        }
                        .bottom-price {
                            font-size: 24px;
                            font-size: clamp(16px, 6cqw, 24px);
                            color: #cb0505;
                            .decorate {
                                font-size: 16px;
                                font-size: clamp(12px, 3.8cqw, 16px);
                            }
                        }
                    }
                    .action {
                        display: flex;
                        align-items: flex-end;
                        flex-shrink: 0;
                        .item {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 90px;
                            width: clamp(64px, 17cqw, 90px);
                            height: 36px;
                            height: clamp(30px, 8.5cqw, 36px);
                            color: #fff;
                            background-color: #4b45ff;
                        }
                        .lose {
                            background-color: #12c1c1;
                        }
                        .finish {
                            background-color: #aaa;
                            cursor: default;
                        }
                    }
                }
            }
        }
    }
}
</style>
